/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RestructuringRequestReportItem {
  id?: string;
  attributeId?: string | null;
  variableType?: RestructuringRequestReportItemVariableTypeEnum | null;
  value?: string | null;
  isEditable?: boolean;
  assignmentId?: string;
}
export enum RestructuringRequestReportItemVariableTypeEnum {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  Boolean = 'Boolean',
  Country = 'Country',
  Currency = 'Currency',
  Percentage = 'Percentage'
}
